// disable patching requestAnimationFrame
/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).__Zone_disable_requestAnimationFrame = true;

// disable patching specified eventNames
/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['message'];
